import { useEffect, useState } from 'react';

import useSWR from 'swr';

// Utils
import { get, patch } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// Lib
import { POST, STORY } from '@/lib/posts/postTypes';

// Api endpoints
import {
    GROUP_MEDIA as GROUP_MEDIA_ENDPOINT,
    MEDIA as MEDIA_ENDPOINT,
    STORY as STORY_ENDPOINT
} from '@/routes/apiEndpoints';

const useMedia = ({
    groupID,
    spID,
    mediaID,
    type = POST,
    requestParams = {},
    withPrevNext = false,
    options = {}
} = {}) => {
    const [launchRequest, setLaunchRequest] = useState(false);
    const getEndpointUrl = (groupId) => {
        let endpoint = GROUP_MEDIA_ENDPOINT;
        if (!groupId) {
            endpoint = type === STORY ? STORY_ENDPOINT : MEDIA_ENDPOINT;
        }
        return injectEndpointUrlParams(endpoint, {
            GROUP_ID: groupId,
            SPID: spID,
            mediaID
        });
    };
    const endpointUrl = getEndpointUrl(groupID);

    const {
        data,
        mutate: mutateMedia,
        error: mediaError,
        isLoading
    } = useSWR(
        launchRequest ? endpointUrl : null,
        (url) =>
            get(
                url,
                withPrevNext ? { ...requestParams, with_pagination: true } : requestParams
            ).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    const patchMedia = async () => {
        try {
            await patch(`${getEndpointUrl()}/followers`);
        } catch {
            // Don't remove this catch to not trigger error if the request fail
        } finally {
            setLaunchRequest(true);
        }
    };

    useEffect(() => {
        if (!launchRequest) {
            patchMedia();
        }
    }, [launchRequest]);

    return {
        media: data ? (type === STORY ? data.story : data.media) : null,
        previousMedia: data ? (type === STORY ? data.previous_story : data.previous_media) : null,
        nextMedia: data ? (type === STORY ? data.next_story : data.next_media) : null,
        mutateMedia,
        mediaError,
        isLoading: isLoading || !launchRequest
    };
};
export default useMedia;
